<template>
	<div>
		<div class="w-100 d-flex align-center main-select">
			<el-select
				class="w-100 select-address"
				:class="{ 'not-map': !visibleMap}"
				:style="`background-color:${globalColors.border}`"
				:value="value"
				v-bind="$attrs"
				@input="selected"
			>
				<el-option
					v-for="(item, indexItem) in optionsComputed"
					:key="indexItem"
					:label="item.itemText"
					:value="item.itemValue"
				>
				</el-option>
			</el-select>
			<el-button
				v-if="noMap"
				class="address-btn"
				:style="`background-color:${globalColors.primary};border:0.1rem solid ${globalColors.primary}`"
				:class="{ 'disable-style': noLocationFound }"
				:disabled="noLocationFound"
				@click="openModalAction"
			>
				<img :src="location" alt="localizador" class="location">
			</el-button>
		</div>
		<section>
			<modal-component
				:title="modalTitle"
				:before-close="closeModalAction"
				:visible="openModal"
			>
				<map-component
					:zoom="zoom"
					:all-markers="warehouseMarkers"
					:location="itemSelectedPosition"
					@choosed-warehouse="choosedWarehouse"
				/>
			</modal-component>
		</section>
	</div>
</template>
<script>
import modalComponent from '@/components/modalGeneric';
import mapComponent from '@/components/mapComponent';

function selected(val) {
	this.$emit('input', val);
	this.itemSelected = this.optionsComputed.find(o => o.itemValue === val);
}

function openModalAction() {
	this.openModal = true;
}

function closeModalAction() {
	this.openModal = false;
}

function choosedWarehouse({ id }) {
	this.selected(id);
	this.closeModalAction();
}

function warehouseMarkers() {
	this.itemSelectedPosition = {};
	this.zoom = 11;
	this.noLocationFound = !this.itemSelected.location && !!this.itemSelected.id;
	const noWarehouse = !this.itemSelected.id;
	if (!noWarehouse && this.itemSelected.location) {
		const { location: { x, y } } = this.itemSelected;
		this.itemSelectedPosition = { lat: x, lng: y };
		this.zoom = 18;
	}
	return noWarehouse ? this.optionsComputed : [];
}

function optionsComputed() {
	this.noLocationFound = true;
	return this.options.map((o) => {
		const newO = { ...o };
		newO.itemText = this.itemText ? o[this.itemText] : this.itemText;
		newO.itemValue = this.itemValue ? o[this.itemValue] : o;
		if (o.location) {
			this.noLocationFound = false;
		}
		return newO;
	});
}

function modalTitle() {
	return this.itemSelected[this.itemTitle];
}

function data() {
	return {
		itemSelected: {
			id: 0,
		},
		itemSelectedPosition: {
			lat: 0,
			lng: 0,
		},
		location: '/static/img/icons/location.svg',
		noLocationFound: true,
		openModal: false,
		zoom: 11,
	};
}

export default {
	name: 'select-address-component',
	components: {
		mapComponent,
		modalComponent,
	},
	computed: {
		modalTitle,
		optionsComputed,
		warehouseMarkers,
	},
	data,
	inheritAttrs: false,
	methods: {
		choosedWarehouse,
		closeModalAction,
		openModalAction,
		selected,
	},
	props: {
		itemText: {
			default: 'Defina item-text',
			type: String,
		},
		itemTitle: {
			default: 'Título',
			type: String,
		},
		itemValue: {
			default: '',
			type: String,
		},
		noMap: {
			default: true,
			type: Boolean,
		},
		options: {
			default: () => [],
			type: Array,
		},
		value: null,
		disabled: {
			type: Boolean,
			default: false,
		},
		visibleMap: {
			type: Boolean,
			default: true,
		},
	},
};
</script>
<style lang="scss" scoped>

	.main-select {
		height: 4.5rem;
	}

	.address-btn {
		border-radius: 0 0.4rem 0.4rem 0;
		height: 100%;
		padding: 0;
		width: 4.3rem;
	}

	.disable-style {
		opacity: 0.4;
	}
</style>



// WEBPACK FOOTER //
// selectAddressComponent.vue?d773c85e